<template>
  <Transition>
    <span
      v-if="kb.warnings.length > 0"
      class="cursor-pointer"
      @click="popupOpen = true"
    >
      <div class="tooltip" data-tip="Configuration warnings, click to see">
        <div class="flex flex-row items-end hover:scale-110">
          <Icon icon="bi:exclamation-triangle-fill" />
          <span v-if="kb.warnings.length > 1" class="text-sm pl-[1px]">
            {{ kb.warnings.length }}
          </span>
        </div>
      </div>
    </span>
  </Transition>
</template>

<script setup lang="ts">
import { useKeyboardStore } from "@/stores";
const kb = useKeyboardStore();
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  @apply transition-all duration-200;
}

.v-enter-from,
.v-leave-to {
  @apply opacity-0 scale-50;
}
</style>
